import cn from "classnames";
import { memo } from "react";
import Icon from "../Icon/Icon";
import styles from "./Checkbox.module.scss";
import { CheckboxPropsI } from "./Checkbox.props";

function Checkbox({
  checked,
  radio,
  text,
  isError = false,
  className,
  icon,
  pulse,

  onClick,
  ...props
}: CheckboxPropsI) {
  return (
    <div
      className={cn(styles.wrapper, className, {
        [styles.error]: isError,
        [styles.pulse]: !!pulse,
      })}
      {...props}
      title={pulse}
      onClick={onClick}
    >
      <div
        className={cn(styles.check, {
          [styles.radio]: radio,
          [styles.checked]: checked,
        })}
      />
      {icon && <Icon src={icon} className={styles.icon} noHover />}
      {text && <p className={cn(styles.text)}> {text}</p>}
    </div>
  );
}
export default memo(Checkbox);
